import {
    GENERIC_ERROR_HAS_OCCURRED,
    SET_WEB_RELAUNCH_STYLE_ENABLED,
    SET_CALCULATION,
    SET_LANGUAGE_CHOOSER_DISABLED
} from '../actions/constants/action-types';

const INITIAL_STATE = {
    genericError: false,
    isWebRelaunchStyleEnabled: false,
    isLanguageChooserDisabled: false
};

const commonPageDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GENERIC_ERROR_HAS_OCCURRED: {
            const {payload: {genericError, genericErrorType}} = action;
            return {
                ...state,
                genericError,
                genericErrorType
            };
        }
        case SET_WEB_RELAUNCH_STYLE_ENABLED: {
            return {
                ...state,
                isWebRelaunchStyleEnabled: action.payload
            };
        }
        case SET_CALCULATION: {
            return {
                ...state,
                calculation: action.payload
            };
        }
        case SET_LANGUAGE_CHOOSER_DISABLED: {
            return {
                ...state,
                isLanguageChooserDisabled: action.payload
            };
        }
        default:
            return state;
    }
};

export default commonPageDataReducer;
